module.exports = __webpack_public_path__ + "media/images/blog-list-pic2-2e1d95af0e5a64238ec4da29dab772dc.png";